import { css, CSSResult } from 'lit'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'


export const style: CSSResult = css`
  .breadcrumbs-mobile {
    display: contents;

    @media(min-width: ${SCREENS.medium}) {
      display: none;
    }
  }

  .breadcrumbs-desktop {
    display: none;

    @media(min-width: ${SCREENS.medium}) {
      display: contents;
    }
  }
`
